const isAdvanceOrderEnum = Object.freeze({
    YES: 5,
    NO: 10
});
export default isAdvanceOrderEnum;
